import { FormFieldConfig } from '@shared/interfaces/config';
import Vue from 'vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import DateTimepicker from '@shared/components/forms/inputs/datetimepicker/datetimepicker.vue';
import CheckboxGroup from '@shared/components/forms/inputs/checkbox-group/checkbox-group.vue';
import Checkbox from '@shared/components/forms/inputs/checkbox/checkbox.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { get, set, unset } from 'lodash';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import File from '@shared/components/forms/inputs/file/file.vue';
import DocumentListGroupInput from '@shared/components/forms/inputs/document-list-group-input/document-list-group-input.vue';
import Section from '@shared/components/forms/inputs/section/section.vue';
import Separator from '@shared/components/forms/inputs/separator/separator.vue';
import FreeText from '@shared/components/forms/inputs/free-text/free-text.vue';
import MultiSelect from '../../inputs/multi-select/multi-select.vue';
import Time from '../../inputs/time/time.vue';
import EntityTableInput from '../../inputs/entity-table-input/entity-table-input.vue';
import SubscriptionTableInput from '@shared/components/forms/inputs/subscription-table-input/subscription-table-input.vue';
import SwitchButton from '../../inputs/switch-button/switch-button.vue';
import DateRange from '../../inputs/date-range/date-range.vue';
import TimeRange from '../../inputs/time-range/time-range.vue';
import ButtonGroup from '../../inputs/button-group/button-group.vue';
import InputHidden from '@shared/components/forms/inputs/input-hidden/input-hidden.vue';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import SuggestedArticles from '../../inputs/suggested-articles/suggested-articles.vue';
import CalendarDisciplineFilter from '../../inputs/calendar-discipline-filter/calendar-discipline-filter.vue';
import Alert from '@shared/components/forms/inputs/alert/alert.vue';
import OrderTableInput from '@shared/components/forms/inputs/order-table-input/order-table-input.vue';
import DirectDebitFileItemTableInput from '@accounting/components/forms/direct-debit-file-item-table-input/direct-debit-file-item-table-input.vue';
import TermsCheckbox from '../../inputs/terms-checkbox/terms-checkbox.vue';
import SubscriptionChecklist from '@shared/components/forms/inputs/subscription-checklist/subscription-checklist.vue';
import CSSEditor from '@shared/components/forms/inputs/css-editor/css-editor.vue';
import EnrollmentTableInput from '@shared/components/forms/inputs/enrollment-table-input/enrollment-table-input.vue';
import Button from '@shared/components/forms/inputs/button/button.vue';
import { CenterSetting } from '@core/interfaces/center-setting';
import IconSelect from '@shared/components/forms/inputs/icon-select/icon-select.vue';
import ContactBirthdatePicker from '../../inputs/contact-birthdate-picker/contact-birthdate-picker.vue';
import MessageEntityTable from '@shared/components/forms/inputs/message-entity-table/message-entity-table.vue';
import InputTags from '@shared/components/forms/inputs/input-tags/input-tags.vue';
import DiscountRule from '@shared/components/forms/inputs/discount_rule/discount-rule.vue';
import RadioGroup from '@shared/components/forms/inputs/radio-group/radio-group.vue';

import DayTimeSlot from '@shared/components/forms/inputs/day-time-slot/day-time-slot.vue';
import DayTimeRepeater from '@shared/components/forms/inputs/day-time-repeater/day-time-repeater.vue';
import DayTimeResponsibleRepeater from '@shared/components/forms/inputs/day-time-responsible-repeater/day-time-responsible-repeater.vue';
import FamilyListGroupInput from '@shared/components/forms/inputs/family-list-group-input/family-list-group-input.vue';
import TeamListGroupInput from '@shared/components/forms/inputs/team-list-group-input/team-list-group-input.vue';
import ContactRelationsListGroupInput from '@shared/components/forms/inputs/contact-relations-list-group-input/contact-relations-list-group-input.vue';
import CustomContactFieldsInput from '@shared/components/forms/inputs/custom-contact-fields-input/custom-contact-fields-input.vue';
import Link from '@shared/components/forms/inputs/link/link.vue';
import AttendeeTableInput from '@shared/components/forms/inputs/attendee-table-input/attendee-table-input.vue';
import PaymentTable from '@accounting/components/tables/payment-table/payment-table.vue';
import ResourceFilter from '@shared/components/filters/resource-filter/resource-filter.vue';
import AccessControlBadgeTableInput from '@access-control/components/forms/access-control-badge-table-input/access-control-badge-table-input.vue';
import FamilyRelationListGroupInput from '@shared/components/forms/inputs/family-relation-list-group-input/family-relation-list-group-input.vue';
import ActivitySessionTableInput from '@shared/components/forms/inputs/activity-session-table-input/activity-session-table-input.vue';
import AccessControlConfigForm from '@shared/components/forms/inputs/access-control-config-form/access-control-config-form.vue';
import { AccessControlConfigInterface } from '@core/interfaces/access-control-config-interface';
import CashMovementTableInput from '../../inputs/cash-movement-table-input/cash-movement-table-input.vue';
import OrganizationRelationListGroupInput from '@shared/components/forms/inputs/organization-relation-list-group-input/organization-relation-list-group-input.vue';

//import Tabs from '@shared/components/forms/inputs/tabs/tabs.vue';
const Tabs = () => import('@shared/components/forms/inputs/tabs/tabs.vue');
const EntityTabs = () => import('@shared/components/forms/inputs/entity-tabs/entity-tabs.vue');
const EntityPills = () => import('@shared/components/forms/inputs/entity-pills/entity-pills.vue');

// import Colorpicker from '@shared/components/forms/inputs/colorpicker/colorpicker.vue';
const Colorpicker = () => import('@shared/components/forms/inputs/colorpicker/colorpicker.vue');
const EntitySelect = () => import('../../inputs/entity-select/entity-select.vue');
const EntitySelectTable = () => import('../../inputs/entity-select-table/entity-select-table.vue');
const EntityGrid = () => import('../../inputs/entity-grid/entity-grid.vue');
const BookingTableInput = () => import('../../inputs/booking-table-input/booking-table-input.vue');
const BookingEventTableInput = () =>
  import('../../inputs/booking-event-table-input/booking-event-table-input.vue');
const SaleSessionBundledSalesTable = () =>
  import(
    '@shared/components/forms/inputs/sale-session-bundled-sales-table/sale-session-bundled-sales-table.vue'
  );
const SaleSessionBundledPaymentsTable = () =>
  import(
    '@shared/components/forms/inputs/sale-session-bundled-payments-table/sale-session-bundled-payments-table.vue'
  );
const PosSessionReport = () =>
  import('@shared/components/forms/inputs/pos-session-report/pos-session-report.vue');
const EntityTypeSelect = () =>
  import('@shared/components/forms/inputs/entity-type-select/entity-type-select.vue');

const CountriesSelector = () => import('../../inputs/countries-selector/countries-selector.vue');

const InvoiceSyncDataDisplay = () =>
  import(
    '@accounting-integrations/components/invoice-sync-data-display/invoice-sync-data-display.vue'
  );
const InvoiceTableInput = () =>
  import('@shared/components/forms/inputs/invoice-table-input/invoice-table-input.vue');

const PosCheckoutOrderItemsList = () =>
  import(
    '@shared/components/forms/inputs/pos-checkout-order-items-list/pos-checkout-order-items-list.vue'
  );

const ActivityLogTimelineInput = () =>
  import(
    '@shared/components/forms/inputs/activity-log-timeline-input/activity-log-timeline-input.vue'
  );

const ExactAuthLink = () =>
  import('@shared/components/forms/inputs/exact-auth-link/exact-auth-link.vue');
const StripeConnectLink = () =>
  import('@shared/components/forms/inputs/stripe-connect/stripe-connect-link.vue');
const DocumentNumberStructureExample = () =>
  import('@shared/components/forms/inputs/document-number-structure-example.vue');
const CodaLineTableInput = () =>
  import('@shared/components/forms/inputs/coda-line-table-input/coda-line-table-input.vue');
const MembershipTableInput = () =>
  import('@shared/components/forms/inputs/membership-table-input/membership-table-input.vue');
const ActivitySessionGameTableInput = () =>
  import(
    '@shared/components/forms/inputs/activity-session-game-table-input/activity-session-game-table-input.vue'
  );
const ActivityGroupTableInput = () =>
  import(
    '@shared/components/forms/inputs/activity-group-table-input/activity-group-table-input.vue'
  );
const CreditNoteClearanceTable = () =>
  import('@accounting/components/others/credit-note-clearance/credit-note-clearance-table.vue');
const AccessControlSaleOverview = () =>
  import(
    '@access-control/components/others/access-control-sale-overview/access-control-sale-overview.vue'
  );

const RandomKeyInput = () => import('@shared/components/forms/inputs/random-key-input.vue');

const AccessPointTableInput = () =>
  import('@access-control/components/tables/access-point/access-point-table-input.vue');

const PostalCodeInput = () =>
  import('@shared/components/forms/inputs/postal-code-input/postal-code-input.vue');
const TppwbPadelInput = () => import('@shared/components/forms/inputs/tppwb-padel-input.vue');
const TppwbTennisInput = () => import('@shared/components/forms/inputs/tppwb-tennis-input.vue');

@Component({
  name: 'bpc-auto-form-input',
  components: {
    'bpc-input': Input,
    'bpc-input-tags': InputTags,
    'bpc-textarea': Textarea,
    'bpc-select': Select,
    'bpc-entity-select': EntitySelect,
    'bpc-entity-select-table': EntitySelectTable,
    'bpc-entity-grid': EntityGrid,
    'bpc-checkbox': Checkbox,
    'bpc-terms-checkbox': TermsCheckbox,
    'bpc-checkbox-group': CheckboxGroup,
    'bpc-datepicker': Datepicker,
    'bpc-datetimepicker': DateTimepicker,
    'bpc-time': Time,
    'bpc-input-group': InputGroup,
    'bpc-colorpicker': Colorpicker,
    'bpc-switch': Switch,
    'bpc-multi-select': MultiSelect,
    'bpc-entity-type-select': EntityTypeSelect,
    'bpc-entity-table-input': EntityTableInput,
    'bpc-subscription-table-input': SubscriptionTableInput,
    'bc-cash-movement-table-input': CashMovementTableInput,
    'bpc-file': File,
    'bpc-document-list-group-input': DocumentListGroupInput,
    'bpc-switch-button': SwitchButton,
    'bpc-date-range': DateRange,
    'bpc-time-range': TimeRange,
    'bpc-button-group': ButtonGroup,
    'bpc-section': Section,
    'bpc-separator': Separator,
    'bpc-free-text': FreeText,
    'bpc-tabs': Tabs,
    'bpc-entity-tabs': EntityTabs,
    'bpc-entity-pills': EntityPills,
    'bpc-text-editor': TextEditor,
    'bpc-input-hidden': InputHidden,
    'bpc-suggested-articles': SuggestedArticles,
    'bpc-calendar-discipline-filter': CalendarDisciplineFilter,
    'bc-resource-filter': ResourceFilter,
    'bpc-alert': Alert,
    'bpc-order-table-input': OrderTableInput,
    'bpc-direct-debit-file-item-table-input': DirectDebitFileItemTableInput,
    'bpc-booking-table-input': BookingTableInput,
    'bpc-booking-event-table-input': BookingEventTableInput,
    'bpc-countries-selector': CountriesSelector,
    'bpc-subscription-checklist': SubscriptionChecklist,
    'bpc-css-editor': CSSEditor,
    'bpc-enrollment-table-input': EnrollmentTableInput,
    'bpc-attendee-table-input': AttendeeTableInput,
    'bpc-activity-session-table-input': ActivitySessionTableInput,
    'bpc-coda-line-table-input': CodaLineTableInput,
    'bpc-activity-log-timeline-input': ActivityLogTimelineInput,
    'bpc-invoice-sync-data-display': InvoiceSyncDataDisplay,
    'bpc-pos-checkout-order-items-list': PosCheckoutOrderItemsList,
    'bc-sale-session-bundled-sales-table': SaleSessionBundledSalesTable,
    'bc-sale-session-bundled-payments-table': SaleSessionBundledPaymentsTable,
    'bpc-pos-session-report': PosSessionReport,
    'bpc-icon-select': IconSelect,
    'bpc-exact-auth-link': ExactAuthLink,
    'bpc-stripe-connect-link': StripeConnectLink,
    'bpc-contact-birthdate-picker': ContactBirthdatePicker,
    'bpc-invoice-table-input': InvoiceTableInput,
    'bpc-message-entity-table': MessageEntityTable,
    'bpc-discount-rule': DiscountRule,
    'bpc-radio-group': RadioGroup,
    'bpc-day-time-slot': DayTimeSlot,
    'bpc-day-time-repeater': DayTimeRepeater,
    'bpc-day-time-responsible-repeater': DayTimeResponsibleRepeater,
    'bpc-button': Button,
    'bpc-family-list-group-input': FamilyListGroupInput,
    'bpc-family-relation-list-group-input': FamilyRelationListGroupInput,
    'bpc-organization-relation-list-group-input': OrganizationRelationListGroupInput,
    'bpc-team-list-group-input': TeamListGroupInput,
    'bpc-contact-relations-list-group-input': ContactRelationsListGroupInput,
    'bpc-custom-contact-fields-input': CustomContactFieldsInput,
    'bpc-display-link': Link,
    'bpc-document-number-structure-example': DocumentNumberStructureExample,
    'bpc-payment-table': PaymentTable,
    'bpc-membership-table-input': MembershipTableInput,
    'bpc-activity-session-game-table-input': ActivitySessionGameTableInput,
    'bpc-credit-note-clearance-table': CreditNoteClearanceTable,
    'bpc-access-control-sale-overview': AccessControlSaleOverview,
    'bpc-access-control-badge-table-input': AccessControlBadgeTableInput,
    'bpc-random-key-input': RandomKeyInput,
    'bpc-activity-group-table-input': ActivityGroupTableInput,
    'bpc-access-control-config-form': AccessControlConfigForm,
    'bpc-access-point-table-input': AccessPointTableInput,
    'bc-postal-code-input': PostalCodeInput,
    'bc-tppwb-padel-input': TppwbPadelInput,
    'bc-tppwb-tennis-input': TppwbTennisInput,
  },
})
export default class AutoFormInput extends Vue {
  @Prop(Object) readonly fieldConfig: FormFieldConfig;
  @Prop(Object) readonly errors: object;
  @Prop(Object) readonly value: AnyEntity;
  @Prop(Boolean) readonly disabled: boolean;
  @Prop(String) readonly disableTag: string;

  @Prop(Boolean) readonly defaultValueSwitchModel: boolean;
  @Prop({ type: [Boolean, String] }) readonly defaultValueSwitchValue: boolean | string;

  @Prop(String) readonly permissionEntityName: string;

  // TODO: add new access control config
  public allowedConditionalModel = ['formModel', 'centerSetting', 'accessControlConfig'];
  public key: number = 1;
  get componentName(): string {
    switch (this.fieldConfig.inputType) {
      case 'input':
        return 'bpc-input';
      case 'input-tags':
        return 'bpc-input-tags';
      case 'textarea':
        return 'bpc-textarea';
      case 'select':
        return 'bpc-select';
      case 'entity-select':
        return 'bpc-entity-select';
      case 'entity-select-table':
        return 'bpc-entity-select-table';
      case 'entity-grid':
        return 'bpc-entity-grid';
      case 'checkbox':
        return 'bpc-checkbox';
      case 'terms-checkbox':
        return 'bpc-terms-checkbox';
      case 'checkbox-group':
        return 'bpc-checkbox-group';
      case 'datepicker':
        return 'bpc-datepicker';
      case 'datetimepicker':
        return 'bpc-datetimepicker';
      case 'time':
        return 'bpc-time';
      case 'input-group':
        return 'bpc-input-group';
      case 'colorpicker':
        return 'bpc-colorpicker';
      case 'switch':
        return 'bpc-switch';
      case 'multi-select':
        return 'bpc-multi-select';
      case 'entity-type-select':
        return 'bpc-entity-type-select';
      case 'entity-table':
        return 'bpc-entity-table-input';
      case 'subscription-table-input':
        return 'bpc-subscription-table-input';
      case 'cash-movement-table-input':
        return 'bc-cash-movement-table-input';
      case 'booking-table':
        return 'bpc-booking-table-input';
      case 'booking-event-table':
        return 'bpc-booking-event-table-input';
      case 'file':
        return 'bpc-file';
      case 'document-list-group':
        return 'bpc-document-list-group-input';
      case 'switch-button':
        return 'bpc-switch-button';
      case 'date-range':
        return 'bpc-date-range';
      case 'time-range':
        return 'bpc-time-range';
      case 'button-group':
        return 'bpc-button-group';
      case 'section':
        return 'bpc-section';
      case 'separator':
        return 'bpc-separator';
      case 'free-text':
        return 'bpc-free-text';
      case 'tabs':
        return 'bpc-tabs';
      case 'entity-tabs':
        return 'bpc-entity-tabs';
      case 'entity-pills':
        return 'bpc-entity-pills';
      case 'text-editor':
        return 'bpc-text-editor';
      case 'hidden':
        return 'bpc-input-hidden';
      case 'suggested-articles':
      case 'multiple-suggested-articles':
        return 'bpc-suggested-articles';
      case 'calendar-discipline-filter':
        return 'bpc-calendar-discipline-filter';
      case 'resource-filter':
        return 'bc-resource-filter';
      case 'alert':
        return 'bpc-alert';
      case 'orders-table':
        return 'bpc-order-table-input';
      case 'direct-debit-file-items-table':
        return 'bpc-direct-debit-file-item-table-input';
      case 'access-control-badges-table':
        return 'bpc-access-control-badge-table-input';
      case 'access-point-table-input':
        return 'bpc-access-point-table-input';
      case 'countries-selector':
        return 'bpc-countries-selector';
      case 'subscription-checklist':
        return 'bpc-subscription-checklist';
      case 'css-editor':
        return 'bpc-css-editor';
      case 'enrollment-table-input':
        return 'bpc-enrollment-table-input';
      case 'attendee-table-input':
        return 'bpc-attendee-table-input';
      case 'activity-group-table-input':
        return 'bpc-activity-group-table-input';
      case 'activity-session-table-input':
        return 'bpc-activity-session-table-input';
      case 'coda-line-table-input':
        return 'bpc-coda-line-table-input';
      case 'activity-logs':
        return 'bpc-activity-log-timeline-input';
      case 'invoice-sync-data-display':
        return 'bpc-invoice-sync-data-display';
      case 'pos-checkout-order-items-list':
        return 'bpc-pos-checkout-order-items-list';
      case 'group-order-items-by-pos-session':
        return 'bc-sale-session-bundled-sales-table';
      case 'group-payments-by-pos-session':
        return 'bc-sale-session-bundled-payments-table';
      case 'pos-session-report':
        return 'bpc-pos-session-report';
      case 'icon-select':
        return 'bpc-icon-select';
      case 'exact-auth-link':
        return 'bpc-exact-auth-link';
      case 'contact-birthdate-picker':
        return 'bpc-contact-birthdate-picker';
      case 'invoice-table-input':
        return 'bpc-invoice-table-input';
      case 'message-entity-table':
        return 'bpc-message-entity-table';
      case 'discount-rule':
        return 'bpc-discount-rule';
      case 'radio-group':
        return 'bpc-radio-group';
      case 'day-time-slot':
        return 'bpc-day-time-slot';
      case 'day-time-repeater':
        return 'bpc-day-time-repeater';
      case 'day-time-responsible-repeater':
        return 'bpc-day-time-responsible-repeater';
      case 'button':
        return 'bpc-button';
      case 'family-list-group':
        return 'bpc-family-list-group-input';
      case 'team-list-group':
        return 'bpc-team-list-group-input';
      case 'family-relation-list-group':
        return 'bpc-family-relation-list-group-input';
      case 'organization-relation-list-group':
        return 'bpc-organization-relation-list-group-input';
      case 'contact-relations-list-group':
        return 'bpc-contact-relations-list-group-input';
      case 'custom-contact-fields':
        return 'bpc-custom-contact-fields-input';
      case 'display-link':
        return 'bpc-display-link';
      case 'document-number-structure-example':
        return 'bpc-document-number-structure-example';
      case 'stripe-connect-link':
        return 'bpc-stripe-connect-link';
      case 'payment-table':
        return 'bpc-payment-table';
      case 'membership-table-input':
        return 'bpc-membership-table-input';
      case 'activity-session-game-table-input':
        return 'bpc-activity-session-game-table-input';
      case 'credit-note-clearance-table':
        return 'bpc-credit-note-clearance-table';
      case 'access-control-sale-overview':
        return 'bpc-access-control-sale-overview';
      case 'random-key-input':
        return 'bpc-random-key-input';
      case 'access-control-config-form':
        return 'bpc-access-control-config-form';
      case 'postal-code':
        return 'bc-postal-code-input';
      case 'tppwb-padel-input':
        return 'bc-tppwb-padel-input';
      case 'tppwb-tennis-input':
        return 'bc-tppwb-tennis-input';
      default:
        // return `bpc-${this.fieldConfig.inputType}`;
        return 'bpc-input';
    }
  }

  get permissionEntityNameFromPropOrFromConfig(): string {
    return this.permissionEntityName
      ? this.permissionEntityName
      : this.fieldConfig.permissionEntityName || null;
  }

  get isDisabled(): boolean {
    if (this.disabled) {
      return true;
    }
    if (this.fieldConfig.disabledByTags) {
      return this.fieldConfig.disabledByTags.includes(this.disableTag);
    }
    return false;
  }

  get conditionalClass(): string {
    let className = null;
    const conditionalClassFieldPath = get(this.fieldConfig, 'conditionalClass.fieldPath', null);
    if (conditionalClassFieldPath) {
      const conditionalClassOperator = get(this.fieldConfig, 'conditionalClass.operator', null);
      const conditionalClassValue = get(this.fieldConfig, 'conditionalClass.value', null);
      const modelValue = get(this.formModel, conditionalClassFieldPath);
      if (this.compare(conditionalClassOperator, modelValue, conditionalClassValue)) {
        className = get(this.fieldConfig, 'conditionalClass.class', null);
      }
    }
    return className;
  }

  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get accessControlConfig(): AccessControlConfigInterface {
    return this.$store.getters['centerSettings/accessControlConfig'];
  }

  get hideField(): boolean {
    let show = true;
    let hide = false;
    const hideMode = get(this.fieldConfig, 'conditionalHideMode', 'or');
    const showMode = get(this.fieldConfig, 'conditionalShowMode', 'or');

    const acumulatedHide = [];
    const acumulatedShow = [];

    if (get(this.fieldConfig, 'conditionalShow', []).length > 1) {
      const conditions = get(this.fieldConfig, 'conditionalShow');
      for (const condition of conditions) {
        const showIfFieldPath = get(condition, 'fieldPath', null);
        if (showIfFieldPath) {
          const showIfOperator = get(condition, 'operator', null);
          const showIfValue = get(condition, 'value', null);
          /**  get the 'formModel' parameter from the field config and then check if it exist in 'this.allowedConditionalModel'
           * if it does,set it to the formModel value, if not, just set the default value to "formModel"
           */
          const formModel = get(condition, 'formModel', 'formModel');
          const showIfFormModel = this.allowedConditionalModel.includes(formModel)
            ? formModel
            : 'formModel';

          const modelValue = get(this, `${showIfFormModel}.${showIfFieldPath}`, null);

          if (showMode === 'or') {
            if (!this.compare(showIfOperator, modelValue, showIfValue)) {
              show = false;
              const actionIfHide = get(condition, 'actionIfHide', null);
              this.manageActionIfHide(actionIfHide);
            } else {
              show = true;
              break;
            }
          } else {
            if (!this.compare(showIfOperator, modelValue, showIfValue)) {
              show = false;
              acumulatedShow.push(show);
              // TODO: implements it, we need to apply actions only if all conditions are false.
              //const actionIfHide = get(condition, 'actionIfHide', null);
              //this.manageActionIfHide(actionIfHide);
            } else {
              show = true;
              acumulatedShow.push(show);
            }
          }
        }
      }
    } else {
      const showIfFieldPath = get(this.fieldConfig, 'conditionalShow.fieldPath', null);
      if (showIfFieldPath) {
        const showIfOperator = get(this.fieldConfig, 'conditionalShow.operator', null);
        const showIfValue = get(this.fieldConfig, 'conditionalShow.value', null);
        const formModel = get(this.fieldConfig, 'conditionalShow.formModel', 'formModel');
        const showIfFormModel = this.allowedConditionalModel.includes(formModel)
          ? formModel
          : 'formModel';
        const modelValue = get(this, `${showIfFormModel}.${showIfFieldPath}`, null);
        if (!this.compare(showIfOperator, modelValue, showIfValue)) {
          show = false;
          const actionIfHide = get(this.fieldConfig, 'conditionalShow.actionIfHide', null);
          this.manageActionIfHide(actionIfHide);
        }
      }
    }

    if (get(this.fieldConfig, 'conditionalHide', []).length > 1) {
      const conditions = get(this.fieldConfig, 'conditionalHide');
      for (const condition of conditions) {
        const hideIfFieldPath = get(condition, 'fieldPath', null);
        if (hideIfFieldPath) {
          const hideIfOperator = get(condition, 'operator', null);
          const hideIfValue = get(condition, 'value', null);
          /**  get the 'formModel' parameter from the field config and then check if it exist in 'this.allowedConditionalModel'
           * if it does,set it to the formModel value, if not, just set the default value to "formModel"
           */
          const formModel = get(condition, 'formModel', 'formModel');
          const hideIfFormModel = this.allowedConditionalModel.includes(formModel)
            ? formModel
            : 'formModel';
          const modelValue = get(this, `${hideIfFormModel}.${hideIfFieldPath}`, null);

          if (hideMode === 'or') {
            if (this.compare(hideIfOperator, modelValue, hideIfValue)) {
              hide = true;
              const actionIfHide = get(condition, 'actionIfHide', null);
              this.manageActionIfHide(actionIfHide);
              break;
            } else {
              hide = false;
            }
          } else {
            if (this.compare(hideIfOperator, modelValue, hideIfValue)) {
              hide = true;
              acumulatedHide.push(hide);
            } else {
              hide = false;
              acumulatedHide.push(hide);
            }
          }
        }
      }
    } else {
      const hideIfFieldPath = get(this.fieldConfig, 'conditionalHide.fieldPath', null);
      if (hideIfFieldPath) {
        const hideIfOperator = get(this.fieldConfig, 'conditionalHide.operator', null);
        const hideIfValue = get(this.fieldConfig, 'conditionalHide.value', null);
        const formModel = get(this.fieldConfig, 'conditionalHide.formModel', 'formModel');
        const hideIfFormModel = this.allowedConditionalModel.includes(formModel)
          ? formModel
          : 'formModel';
        const modelValue = get(this, `${hideIfFormModel}.${hideIfFieldPath}`, null);

        if (this.compare(hideIfOperator, modelValue, hideIfValue)) {
          hide = true;
          const actionIfHide = get(this.fieldConfig, 'conditionalHide.actionIfHide', null);
          this.manageActionIfHide(actionIfHide);
        }
      }
    }

    if (showMode === 'and') {
      show = acumulatedShow.reduce((sum, next) => sum && next, true);
    }
    if (hideMode === 'and') {
      hide = acumulatedHide.reduce((sum, next) => sum && next, true);
    }

    if (this.defaultValueSwitchModel) {
      hide = true;
    }

    return !show || hide;
  }

  manageActionIfHide(actionIfHide = null) {
    switch (actionIfHide) {
      case 'delete':
        this.model = null;
        unset(this.formModel, this.fieldPath);
        this.$emit('input', this.formModel);

        this.key++;
        break;

      default:
        break;
    }
  }

  compare(operator, currentValue, targetValue) {
    switch (operator) {
      case '=':
        return currentValue == targetValue;
      case '!=':
        return currentValue != targetValue;
      case '>':
        return currentValue > targetValue;
      case '<':
        return currentValue < targetValue;
      case '>=':
        return currentValue >= targetValue;
      case '<=':
        return currentValue <= targetValue;
      case 'in':
        if (Array.isArray(currentValue) && operator === 'in') {
          const includeValue = currentValue.some(value => targetValue.includes(value));
          return includeValue;
        }
        return targetValue.indexOf(currentValue) > -1;
      case 'not_in':
        return targetValue.indexOf(currentValue) === -1;
      default:
        return false;
    }
  }

  get fieldPath(): string {
    return get(this.fieldConfig, 'fieldPath', get(this.fieldConfig, 'name'));
  }

  get errorFieldPath(): string {
    return get(this.fieldConfig, 'errorFieldPath', this.fieldPath);
  }

  get attributesToBind() {
    if (
      this.fieldConfig.wrapperAttributes?.class['d-inline-block'] !== null &&
      this.fieldConfig.wrapperAttributes?.class['d-inline-block'] !== undefined
    ) {
      this.fieldConfig.wrapperAttributes.class['d-inline-block'] = !this.hideField;
    }
    const errorBinding = get(this.errors, this.errorFieldPath, {});
    return {
      ...this.fieldConfig,
      ...errorBinding,
    };
  }

  get formModel(): AnyEntity {
    return this.value;
  }
  set formModel(val: AnyEntity) {
    this.$emit('input', val);
  }

  get model() {
    return get(this.formModel, this.fieldPath, null);
  }

  set model(val) {
    this.$emit('field-change', this.fieldPath, this.model);
    set(this.formModel, this.fieldPath, val);
  }

  emitDeleteMediaFile($event) {
    this.$emit('delete-media-file', $event);
  }

  emitInputCustomEvent($event) {
    this.$emit('input-custom-event', $event);
  }

  @Watch('defaultValueSwitchModel')
  onDefaultValueSwitchModelChange() {
    if (this.defaultValueSwitchModel) {
      this.model = this.defaultValueSwitchValue;
    } else {
      this.model = this.fieldConfig.defaultValue;
    }
  }
}
